export const questions = [
     {
          id: 1,
          title: "چرا از فروشکاه شما استفاده کنم؟",
          answer: "فروشگاه ما علاوه بر قیمت عالی امکاناتی دیگری مثل ارسال سریع و امکان پرداخت به صورت حضوری و ... دارد.",
        },
        {
          id: 2,
          title: "چجوری با اپلیکیشن شما کار کنم؟",
          answer:
            "پس از نصب اپلیکیشن با وارد کردن ایمیل و رمز عبور وارد میشوید و میتونید از فروشگاه ما خرید کنید",
        },
        {
          id: 3,
          title: "آیا سیاست بازپرداخت وجود دارد؟",
          answer:
            "در این فروشگاه بر روی همه محصولات امکان بازپرداخت وجود دارد",
        },
]